import http from "../httpService";
import { apiUrl } from "../../../config.js";
import { DateTime } from "luxon";

const apiEndpoint = apiUrl + "/inventory/inventory-report/";

export function getInventoryDashboard(fiscalYearID = 0, fiscalPeriodID = 0) {
  return http.get(
    apiEndpoint + "inventory-dashboard/" + fiscalYearID + "/" + fiscalPeriodID
  );
}

export function getStockValueSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "stock-value-summary/" + fiscalYearID);
}

export function getOrderFulfillmentSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "order-fulfillment-summary/" + fiscalYearID);
}

export function getTopStockValueSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-stock-value-summary/" + fiscalPeriodID);
}

export function getTopStockReorderSummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-stock-reorder-summary/" + fiscalPeriodID);
}

export function getTopStockQuantitySummary(fiscalPeriodID = 0) {
  return http.get(apiEndpoint + "top-stock-quantity-summary/" + fiscalPeriodID);
}

export function getInventoryTurnoverSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "inventory-turnover-summary/" + fiscalYearID);
}

export function getStockOpnameSummary(fiscalYearID = 0) {
  return http.get(apiEndpoint + "stock-opname-summary/" + fiscalYearID);
}

export function getStockAvailabilityReport(warehouseID = 0, outletID = 0) {
  return http.get(
    apiEndpoint + `stock-availability-report/${warehouseID}/${outletID}`
  );
}

export function getStockValueReport(warehouseID = 0, outletID = 0) {
  return http.get(
    apiEndpoint + `stock-value-report/${warehouseID}/${outletID}`
  );
}

export function getStockAgingReport(warehouseID = 0, outletID = 0) {
  return http.get(
    apiEndpoint + `stock-aging-report/${warehouseID}/${outletID}`
  );
}

export function getStocksCountingReport(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day")
) {
  return http.get(apiEndpoint + `stock-counting-report/${dateFrom}/${dateTo}`);
}

export function getItemsRequestReport() {
  return http.get(apiEndpoint + "items-request-report");
}
